
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { SupplierModel } from '@/models/supplier';

@Component
export default class AutoAssignVendorDialog extends Vue {
  @Prop({ default: false }) public readonly value!: boolean;

  private open = false;
  private loading = false;
  private applying = false;
  private conflictMode: 'skip' | 'overwrite' = 'skip';
  private rows: any[] = [];
  private totals: any = { total: 0, willApply: 0, alreadyConfigured: 0, active: 0, inactive: 0 };
  private selectedRows: any[] = [];

  private readonly headers = [
    { text: 'Supplier', value: 'name' },
    { text: 'Status', value: 'status' },
    { text: 'Action', value: 'action' },
    { text: 'Current rule', value: 'currentRuleSummary' },
  ];

  private get selectedIds(): number[] {
    return this.selectedRows.map((r) => r.id);
  }

  @Watch('value', { immediate: true })
  private onValue(v: boolean) {
    this.open = v;
    if (v) { this.loadPreview(); }
  }

  @Watch('open')
  private onOpen(v: boolean) {
    if (!v) { this.$emit('input', false); }
  }

  private async loadPreview() {
    this.loading = true;
    try {
      const res = await SupplierModel.previewAutoAssignVendor();
      this.rows = res.suppliers || [];
      this.totals = res.totals || this.totals;
      this.selectedRows = [];
    } catch (e) {
      this.$emit('error', e);
    } finally {
      this.loading = false;
    }
  }

  private async apply() {
    this.applying = true;
    try {
      const ids = this.selectedIds.length ? this.selectedIds : undefined;
      const result = await SupplierModel.applyAutoAssignVendor(this.conflictMode, ids);
      this.$emit('applied', result);
      this.close();
    } catch (e) {
      this.$emit('error', e);
    } finally {
      this.applying = false;
    }
  }

  private close() {
    this.open = false;
  }
}
